import React, { useEffect, useState } from 'react'
import TableHeader from '../Shared/TableHeader'
import { LeadFormActions } from '../../Services/_actions';
import CommonTable from '../Shared/Tables';
import ReactPagination from '../Shared/Pagination';
import { dateFormate, renderToolTip } from '../../utils/helper';
import SearchBox from '../Shared/SearchBox';
import { Button, Col, Row } from 'react-bootstrap';
import FilterOffcanvas from '../Shared/FilterOffcanvas';
import SelectDropdown from '../Shared/SelectDropdown';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { BackButton } from '../Shared/BackButton';
import DateRangeFilter from '../Shared/DateRangeFilter/DateRangeFilter.tsx';
import FilterListIcon from '@mui/icons-material/FilterList';
import LongStringView from '../Shared/LongStringView/index.tsx';

const AgentUsers = () => {
    const { agentName, agentNumber, callingDate,dispositionStatus } = useParams();
    const navigate = useNavigate();
    const leadFormActions = LeadFormActions();
    const [agentUsersData, setAgentUsersData] = useState({});
    const [filterObj, setFilterObj] = useState({ agentNumber: agentNumber, date: callingDate, page: 0, limit: 10, disposition: dispositionStatus });
    const [isLoading, setIsLoading] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const initialColumns = [
        {
            dataField: 'index',
            text: 'S.No.',
            formatter: (cell, row, rowIndex) => rowIndex + 1,
            headerAlign: 'center',
            align: 'center',
            headerStyle: { width: '50px' }
        },
        {
            dataField: 'end_customer_number',
            text: 'Number',
            headerAlign: 'center',
            align: 'center',
            headerStyle: { width: '120px' },

        },
        {
            dataField: 'start_time',
            text: 'Time',
            headerAlign: 'center',
            align: 'center',
            headerStyle: { width: '120px' },
            formatter: (cell, row) => { return (<span>{dateFormate(row?.start_time, "hh:mm A")}</span>) }
        },
        {
            dataField: 'sent_count',
            text: 'Audio',
            headerAlign: 'center',
            align: 'center',
            headerStyle: { width: '320px' },
            formatter: (cell, row,rowIndex) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <audio id={`audio-player-${rowIndex}`} controls   >
                            <source src={row?.resource_url || ''} type="audio/mpeg" />
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                )
            }
        },

        {
            dataField: 'comment',
            text: 'Comment',
            headerAlign: 'center',
            align: 'center',
            formatter: (cell, row) => {
                return (
                    <LongStringView longString={row?.comment ?? ''}/>
                )
            }
        },
    ]

    const clearFilters = () => {
        let obj = {
            agentNumber: agentNumber, date: callingDate, page: 0, limit: 10, disposition: ''
        }
        setFilterObj(obj);
        getAgentUsers(obj);
    }

    const getAgentUsers = async (obj) => {
        setIsLoading(true);
        let res = await leadFormActions.getAgentUsers(obj);
        if (res?.status === 200)
            setAgentUsersData(res?.data || {});
        setIsLoading(false);
    }

    const onPageChange = (e) => {
        setFilterObj({ ...filterObj, page: e?.selected });
        getAgentUsers({ ...filterObj, page: e?.selected });
    }

    const onSearch = (e) => {
        setFilterObj({ ...filterObj, search: e });
        if (e.length > 2 || !e)
            getAgentUsers({ ...filterObj, search: e, page: 0 });
    }


    const handleTableChange = (type, { sortField, sortOrder, data }) => {
        // if (type === 'sort') {
        //     if (sortField !== filters.sort_by || sortOrder !== filters.order) {
        //         setFilterObj({ ...filters, sort_by: sortField, order: sortOrder });
        //         setAgentUsersData({ ...filters, sort_by: sortField, order: sortOrder });

        //     }
        // }
    }

    const backButton = () => {
        return (
            <BackButton onClick={() => navigate(-1)} />
        );
    };

    useEffect(() => {
        getAgentUsers(filterObj)
    }, [])

    return (
        <>
            <TableHeader headerValue={`${agentNumber}-${agentName}-${callingDate}`} isBackButton={backButton} />
            <div className='d-flex'>
                <div>
                    {renderToolTip(
                        'Filters',
                        <FilterListIcon
                            style={{ fontSize: '20px', margin: '5px', cursor: 'pointer' }}
                            onClick={() => {
                                setShowFilter(true);
                            }}
                        />
                    )}
                </div>
                <div className="pb-2">
                    <SearchBox onSearch={onSearch} placeholder='Search' value={filterObj?.search} />
                </div>{' '}
            </div>

            <CommonTable
                id={'index'}
                columnsData={initialColumns}
                rowData={agentUsersData?.list || []}
                // defaultSorted={[{ dataField: filterObj?.sort_by, order: filterObj?.order }]}
                handleTableChange={handleTableChange}
                remote={{ sort: true }}
                isLoading={isLoading}
            />
            <ReactPagination
                pageNo={filterObj?.page}
                pageSize={filterObj?.limit}
                totalItems={agentUsersData?.count}
                onPageChange={onPageChange}
            />

            <FilterOffcanvas
                show={showFilter}
                onHide={() => setShowFilter(false)}
                bodyData={
                    <>
                        <div className='mb-3'>
                            <DateRangeFilter
                                isClearable={true}
                                handleDateChange={(dates) => {
                                    setFilterObj({ ...filterObj, startDate: dates[0], endDate: dates[1] });
                                }}
                                startDate={filterObj?.startDate}
                                endDate={filterObj?.endDate}
                                onApply={() => {
                                    getAgentUsers(filterObj);
                                    setShowFilter(false);
                                }}
                            />
                        </div>
                        <Row>
                            <Col>
                                <Button variant="primary" onClick={() => { getAgentUsers(filterObj), setShowFilter(false) }}>Submit</Button>
                            </Col>
                            <Col>
                                <Button variant="secondary" onClick={() => { clearFilters(), setShowFilter(false) }}>Clear</Button>
                            </Col>
                        </Row>
                    </>
                }
            />
        </>
    )
}

export default AgentUsers